



















































































import Vue from "vue";

export default Vue.extend({
  name: "reset-password-form",

  data() {
    return {
      newPassword: {
        newPassword: "",
        confirmNewPassword: "",
      },
    };
  },

  props: {
    confirmCurrentPassword: {
      type: Boolean,
      default: false,
    },
    buttonPosition: {
      type: String,
      default: "horizon",
    },
    forgotPassword: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // const { newPassword } = this.newPassword;
          this.$emit("setNewPassword", this.newPassword);
          this.newPassword.newPassword = "";
          this.newPassword.confirmNewPassword = "";
          this.$nextTick(() => this.$validator.reset());
        }
      });
    },
  },
  computed: {
    currentLabel(): string {
      return this.forgotPassword ? "認証コード" : "現在のパスワード";
    },
  },
});
